export const apiUrl = (...endpoints) => {
  let path = endpoints.join('/')
  return `/api/${path}/`
}

export const aiApiUrl = (...endpoints) => {
  let path = endpoints.join('/')
  return `https://chatgpt.dentco.tw/api/${path}/`
}
